import React from 'react'
import classNames from 'classnames'

const AlertTips = props => {
    const { clear, noBg, className, type, onClose } = props
    return (
        <div
            className={classNames('spaui-alert', type, className, {
                'with-addons': clear,
                [`spaui-alert-${type}`]: !noBg,
            })}
        >
            <i className={`spaui-alert-icon icon-${type ? type : ''}`}></i>
            <div className="spaui-alert-content">{props.children}</div>
            {clear ? (
                <button className="spaui-alert-close" onClick={e => onClose(e)}>
                    <i className="spaui-icon spaui-icon-remove"></i>
                </button>
            ) : null}
        </div>
    )
}

export default AlertTips
